import * as React from 'react';
export const bireSvg = React.forwardRef(function bireSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#0F5499',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M15.89 12.33c.34-2.06 8.77-2.35 8.77-4.45 0-.05.05-.1.1-.1s.1.05.1.1v2.23c0 2.65-8.5 2.3-8.9 4.85-.01.06-.02.1-.07.1-.06 0-.07-.04-.08-.1-.4-2.54-8.9-2.2-8.9-4.85V7.88c0-.05.05-.1.1-.1s.1.05.1.1c0 2.1 8.43 2.39 8.78 4.45zm0 4.52c.34-2.06 8.77-2.34 8.77-4.44a.1.1 0 0 1 .2 0v2.22c0 2.66-8.5 2.31-8.9 4.85-.01.06-.02.1-.07.1-.06 0-.07-.04-.08-.1-.4-2.54-8.9-2.2-8.9-4.85v-2.22a.1.1 0 0 1 .2 0c0 2.1 8.43 2.38 8.78 4.44zm0 4.64c.34-2.06 8.77-2.34 8.77-4.44a.1.1 0 0 1 .2 0v2.22c0 2.65-8.5 2.31-8.9 4.85-.01.06-.02.1-.07.1-.06 0-.07-.04-.08-.1-.4-2.54-8.9-2.2-8.9-4.85v-2.22a.1.1 0 0 1 .2 0c0 2.1 8.43 2.38 8.78 4.44z',
      }),
    ),
  );
});
bireSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bire = {
  category: 'brand',
  colorable: false,
  name: 'bire',
  svg: bireSvg,
};
